import React from 'react'
import {Button, Col, Divider, Form, Input, message, Row} from "antd";
import {DeleteTwoTone} from "@ant-design/icons";


const CustomerBulkRelevant = ({updater}) => {

    const [form] = Form.useForm()

    const saveRelevant = ({relevants}) => updater([...relevants])

    return (
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <h4>İlgililer</h4>
                </Col>
            </Row>
            <div>
                <Form name={'address-bulk'} onFinish={saveRelevant} form={form}>
                    <Form.List name={'relevants'}>
                        {(addressList, {add, remove}) => (
                            <>
                                {
                                    addressList.map(({key, name}) => {
                                        return (
                                            <div key={key}>
                                                <Row justify={'space-between'}>
                                                    <Col span={20}>
                                                        <Form.Item name={[name, 'name']}
                                                                   rules={[
                                                                       {required: true, message: 'Lütfen Boş Bırakmayınız'}
                                                                   ]}
                                                        >
                                                            <Input placeholder={'Adı'} onBlur={form.submit}/>
                                                        </Form.Item>
                                                        <Form.Item name={[name, 'surname']}
                                                                   rules={[
                                                                       {required: true, message: 'Lütfen Boş Bırakmayınız'}
                                                                   ]}
                                                        >
                                                            <Input placeholder={'Soyadı'} onBlur={form.submit}/>
                                                        </Form.Item>
                                                        <Form.Item name={[name, 'phone']}
                                                                   rules={[
                                                                       {required: true, message: 'Lütfen Boş Bırakmayınız'}
                                                                   ]}
                                                        >
                                                            <Input placeholder={'Telefonu'} onBlur={form.submit}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <DeleteTwoTone onClick={() => remove(name)} />
                                                    </Col>
                                                </Row>
                                                <Divider />
                                            </div>
                                        )
                                    })
                                }
                                <Form.Item>
                                    <Row justify={'center'}>
                                        <Button type={'link'} onClick={() => add()}>Yeni Ekle</Button>
                                    </Row>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form>
            </div>
        </React.Fragment>
    )
}
export default CustomerBulkRelevant